var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-display-wrapper"},[_c('div',{staticClass:"picture",style:(_vm.setBg(_vm.picture_url)),on:{"click":function($event){return _vm.$emit('display-click')}}},[_c('span',{class:['channel-type', _vm.channel_type.toLowerCase()]})]),_c('label',{staticClass:"content-display-label"},[_vm._v(_vm._s(_vm.channel_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }